import { RawRequest } from './RawRequest';
var RawRequestFactory = (function () {
    function RawRequestFactory() {
    }
    RawRequestFactory.createFromString = function (json) {
        return RawRequestFactory.createFromObject(JSON.parse(json));
    };
    RawRequestFactory.createFromObject = function (json) {
        var header = json.header;
        if (header) {
            if (header.id_job) {
                delete header.id_job;
            }
            if (header.resend_counter) {
                delete header.resend_counter;
            }
        }
        return new RawRequest(json);
    };
    return RawRequestFactory;
}());
export { RawRequestFactory };
//# sourceMappingURL=RawRequestFactory.js.map